import _ from 'lodash'
import type { Ref } from '@wix/materializer'
import { Component, pointers, SlotsDataItem } from '@wix/thunderbolt-becky-types'
import { createByRefsisCompNode } from '../../compNodeUtils'

type Dependencies = Ref<SlotsDataItem> | undefined
type ViewItem = Component | null

const {
	data: {
		DATA_MAPS: { SLOTS },
	},
} = pointers

export const ComponentStructureWithSlots = createByRefsisCompNode<Dependencies, ViewItem>({
	getDependencies: (__, { slotsQuery }, scopedCreateRef) =>
		slotsQuery ? scopedCreateRef<SlotsDataItem>(SLOTS, slotsQuery) : undefined,
	toViewItem: (structure, slotsDataItem) => {
		if (!slotsDataItem) {
			return null
		}

		if (slotsDataItem && !_.isEmpty(slotsDataItem.slots)) {
			return {
				...structure,
				slots: slotsDataItem.slots,
			}
		}

		return structure
	},
})
